import React, { useRef, useState } from "react";
import { Button, Modal } from "antd";
import { YoutubeFilled } from "@ant-design/icons";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

const AudioPlayerComponent = ({ file }: { file?: any }) => {
  const [modal2Open, setModal2Open] = useState(false);

  const iframeRef = useRef<HTMLIFrameElement>(null);
  const BASE_URL = `${window.location.origin}/personalize/admin/storage`;


  const handleModalClose = () => {
    // Stop the video by resetting the iframe src
    if (iframeRef.current) {
      const currentSrc = iframeRef.current.src;
      iframeRef.current.src = "";
      setTimeout(() => {
        if (iframeRef.current) {
          iframeRef.current.src = currentSrc;
        }
      }, 100);
    }
    setModal2Open(false);
  };

  return (
    <>
      <div className="btn-holder video-modal">
        <Button
          type="text"
          onClick={() => setModal2Open(true)}
          className="video-modal-btn relative"
        >
          <YoutubeFilled />
        </Button>
      </div>

      <Modal
        centered
        open={modal2Open}
        onOk={handleModalClose}
        onCancel={handleModalClose}
        footer={false}
        width="90vw"
        style={{ maxWidth: "600px" }}
      >
        {modal2Open && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "300px",
            }}
          >
            {/* <AudioPlayer
              autoPlay
              src={`https://skincare.ktmlabs.com/personalize/admin/storage/${file}`}
              onPlay={(e) => console.log("onPlay")}
              // other props here
            /> */}
            <AudioPlayer
  autoPlay
  src={`${BASE_URL}/${file}`}
  onPlay={() => console.log("onPlay")}
/>
          </div>
        )}
      </Modal>
    </>
  );
};

export default AudioPlayerComponent;
